import Limitation from './Limitation'
import { FormValueSelector } from '../../../../Common/forms'
import withListingGpm from '../../../Common/HOC/withListingGpm'

const FormValueLimitation = (props) => (
  <FormValueSelector
    selector={select => ({
      proposalType: select('setting.proposalType'),
      readOnly: select('setting.readOnly'),
      cvsQtyLimitMax: select('setting.cvsQtyLimitMax'),
      userCvsPurchaseQtyLimit: select('setting.userCvsPurchaseQtyLimit'),
      mustShowFormError: select('mustShowFormError'),
      shipTypeId: select('product.shipType.id'),
      price: select('listing.price'),
      applyLowGpm: select('listing.applyLowGpm')
    })}
  >
    {values => {
      return (
        <Limitation
          {...props}
          {...values}
        />
      )
    }}
  </FormValueSelector>
)

const LimitationContainer = withListingGpm(FormValueLimitation)

export default LimitationContainer
